import { observable, makeObservable, action } from 'mobx'
import InputStore from 'stores/InputStore'
import DateInputStore from 'stores/DateInputStore'
import { EMAIL, REQUIRED, REQUIRED_BIRTH_DATE, REQUIRED_DNI_CUIL } from 'util/validationMapping'

class Insured {
    constructor() {
        this.identityNumber = new InputStore(REQUIRED_DNI_CUIL)
        this.birthDate = new DateInputStore(REQUIRED_BIRTH_DATE)
        this.fullName = new InputStore(REQUIRED)
        this.email = new InputStore(EMAIL)

        makeObservable(this, {
            // observables
            identityNumber: observable,
            birthDate: observable,
            fullName: observable,
            email: observable,
            // actions
            setIdentityNumber: action,
            setBirthDate: action,
            setFullName: action,
            setEmail: action,
        })
    }

    setIdentityNumber(value) {
        this.identityNumber.setValue(value)
    }

    setBirthDate(value) {
        this.birthDate.setValue(value)
    }

    setFullName(value) {
        this.fullName.setValue(value)
    }

    setEmail(value) {
        this.email.setValue(value)
    }

    clearErrors() {
        this.identityNumber?.clearError()
        this.birthDate?.clearError()
        this.fullName?.clearError()
        this.email?.clearError()
    }

    async validate() {
        await this.identityNumber?.validate()
        await this.birthDate?.validate()
        await this.fullName?.validate()
        await this.email?.validate()
    }

    json() {
        return {
            identityNumber: this.identityNumber?.value,
            birthDate: this.birthDate?.value?.format("YYYY/MM/DD"),
            fullName: this.fullName?.value,
            email: this.email?.value,
        }
    }

    fromAPI(data) {
        this.setIdentityNumber(data?.identityNumber)
        this.setBirthDate(data?.birthDate)
        this.setFullName(data?.fullName)
        this.setEmail(data?.email)

        setTimeout(() => this.clearErrors(), 1)
    }
}

export default Insured
